const LAST_SEEN_FALLBACK = '--';

const LAST_SEEN_AT_FORMAT: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
};

/**
 * Locale-aware last-seen display: hour, minute, month, day, and year.
 * Falls back to "--" when the ISO timestamp is missing or unparseable.
 */
export function formatLastSeenAt(
  isoDate: string | null | undefined,
): string {
  if (!isoDate) {
    return LAST_SEEN_FALLBACK;
  }

  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) {
    return LAST_SEEN_FALLBACK;
  }

  return date.toLocaleString(undefined, LAST_SEEN_AT_FORMAT);
}
